import React, { useEffect } from 'react'

import { Button, Stack, Typography } from '@mui/material'
import { useSelector } from 'react-redux'

import type { RootState } from 'reduxStore'

import PoziLogo from 'img/pozi.svg'
import { POZI_HOMEPAGE_URL } from 'utils/constants'

const styles = {
  eventId: {
    fontSize: '0.75rem',
    color: 'gray'
  },
  logo: {
    height: 150,
    paddingBottom: 12,
    paddingTop: 48
  },
  pageContainer: { height: '60vh' },
  poziButton: {
    justifyContent: 'center',
    textAlign: 'center' as const,
    textTransform: 'uppercase' as const,
    width: 200
  }
}

// This error page is a temporary placeholder until it is decided how to properly handle API errors
const ErrorPage: React.FC = () => {
  const appError = useSelector((state: RootState) => state.app.error)

  useEffect(() => {
    document.title = 'Pozi'
  }, [])

  if (!appError) {
    return null
  }

  const handleGoToPozi = () => {
    window.location.href = POZI_HOMEPAGE_URL
  }

  const Logo = <img src={PoziLogo} alt="Pozi Logo" style={styles.logo} />

  return (
    <Stack direction="column" alignItems="center" spacing={6} sx={styles.pageContainer}>
        {Logo}
        <Stack direction="column" spacing={1} alignItems="center">
          <Typography variant="body1">
            {appError.description}
          </Typography>
          {appError.isFatal && (<Typography variant="body1">
            If the problem persists, please contact your support team for assistance.
          </Typography>)}
          {appError.event_id && (<Typography variant="body1" sx={styles.eventId}>
          Event ID: {appError.event_id}
        </Typography>)}
        </Stack>
        <Button onClick={handleGoToPozi} sx={styles.poziButton}>
          Go to Pozi.com
        </Button>
    </Stack>
  )
}

export default ErrorPage
